export enum PropertyType {
    UNIQUE = 'unique',
    MULTIPLE = 'multiple',
}
